import React, { Component } from "react";
import { dataToJS, pathToJS, firebaseConnect } from "react-redux-firebase";
import "./style.scss";
import { connect } from "react-redux";
import { debounce } from "throttle-debounce";
import Textarea from "react-textarea-autosize";

class MultipleChoiceQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      response: props.response ? props.response.value : null
    };
  }

  hashCode(str) {
    var hash = 0, i, chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  update(event) {
    this.setState({ response: event.target.value });
    this.props.onChange({ value: event.target.value });
  }

  componentWillReceiveProps(props) {
    this.state = {
      response: props.response ? props.response.value : null
    };
  }

  render() {
    return (
      <div>
        <h4>{this.props.question.title}</h4>
        {this.props.print
          ? <p>
              {this.props.response
                ? this.props.question.mcOptions[this.state.response]
                : <em>No Response</em>}
            </p>
          : this.props.question.mcOptions.map((option, idx) => (
              <div key={this.hashCode(this.props.question.title) + "" + idx}>
                <input
                  type="radio"
                  value={idx}
                  id={this.hashCode(this.props.question.title) + "" + idx}
                  checked={this.state.response == idx}
                  onChange={this.update.bind(this)}
                />
                <label
                  htmlFor={this.hashCode(this.props.question.title) + "" + idx}
                >
                  {option}
                </label>
              </div>
            ))}
      </div>
    );
  }
}

class FreeResponseQuestion extends Component {
  constructor(props) {
    super(props);
  }
  update(event) {
    this.props.onChange({ value: event.target.value });
  }

  render() {
    return (
      <div className={"flex-container"}>
        <h4>{this.props.question.title}</h4>
        {this.props.print
          ? <p>
              {this.props.response
                ? this.props.response.value
                : <em>No Response</em>}
            </p>
          : <Textarea
              disabled={this.props.disabled}
              type="text"
              placeholder={"Your Response"}
              onChange={this.update.bind(this)}
              defaultValue={
                this.props.response ? this.props.response.value : ""
              }
            />}
      </div>
    );
  }
}

class FavoriteQuestion extends Component {
  constructor(props) {
    super(props);
    console.log("FQ:", props);
    this.state = {
      favoriteQuestion: props.response ? props.response.favoriteQuestion : null,
      reason: props.response ? props.response.reason : ""
    };
  }

  updateFavoriteQuestion(event) {
    this.setState({ favoriteQuestion: event.target.value });
    this.props.onChange({
      reason: this.state.reason,
      favoriteQuestion: event.target.value
    });
  }

  updateReason(event) {
    this.setState({ reason: event.target.value });
    this.props.onChange({
      reason: event.target.value,
      favoriteQuestion: this.state.favoriteQuestion || "0-0"
    });
  }

  componentWillReceiveProps(props) {
    this.state = {
      favoriteQuestion: props.response ? props.response.favoriteQuestion : null,
      reason: props.response ? props.response.reason : ""
    };
  }

  render() {
    return (
      <div className={"flex-container"}>

        <h4>What is your favorite question?</h4>
        {this.props.print
          ? this.state.favoriteQuestion
              ? this.props.questions.map(
                  (option, idx) =>
                    option &&
                    option.value &&
                    option._key === this.state.favoriteQuestion &&
                    <p value={option._key} key={option._key}>
                      {option.value}
                    </p>
                )
              : this.props.questions
                  ? <p>{this.props.questions[0].value}</p>
                  : <em>No Response</em>
          : <select
              value={this.state.favoriteQuestion}
              onChange={this.updateFavoriteQuestion.bind(this)}
            >

              {this.props.questions.map(
                (option, idx) =>
                  option &&
                  option.value &&
                  <option value={option._key} key={option._key}>
                    {option.value}
                  </option>
              )}
            </select>}

        <h4>Why do you like this question?</h4>
        {this.props.print
          ? <p>
              {this.state.reason ? this.state.reason : <em>No Response</em>}
            </p>
          : <Textarea
              type="text"
              placeholder={"Your Response"}
              onChange={this.updateReason.bind(this)}
              defaultValue={this.state.reason}
            />}
      </div>
    );
  }
}

class Question extends Component {
  constructor(props) {
    super(props);
    console.log("Q: ", props);
  }

  update(value) {
    this.props.onChange(value);
  }

  render() {
    switch (this.props.question.type) {
      case "Free Response":
        return (
          <FreeResponseQuestion
            question={this.props.question}
            disabled={this.props.disabled}
            print={this.props.print}
            response={this.props.value}
            onChange={debounce(300, this.update.bind(this))}
          />
        );
      case "Multiple Choice":
        return (
          <MultipleChoiceQuestion
            question={this.props.question}
            disabled={this.props.disabled}
            print={this.props.print}
            response={this.props.value}
            onChange={debounce(10, this.update.bind(this))}
          />
        );
      case "2":
        if (this.props.responses && this.props.responses.group) {
          let favoriteQuestionOptions = Object.keys(this.props.responses.group)
            .map(key => this.props.responses.group[key])
            .map((g, i) => ({ ...g, index: i }))
            .reduce(
              (arr, group) =>
                group
                  ? arr.concat(
                      (group.question instanceof Array
                        ? group.question
                        : []).map((q, i) => ({
                        ...q,
                        _key: `${group.index}-${i}`
                      }))
                    )
                  : arr,
              []
            );
          console.log(favoriteQuestionOptions);
          return (
            <FavoriteQuestion
              question={this.props.question}
              disabled={this.props.disabled}
              print={this.props.print}
              questions={favoriteQuestionOptions}
              response={this.props.value}
              onChange={debounce(300, this.update.bind(this))}
            />
          );
        }
      default:
        return null;
    }
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/containers/question/index.js